import { Reducer, combineReducers } from 'redux'
import { DashboardUIState, DashboardActionTypes } from './types'

// Type-safe initialState!
const initialState: DashboardUIState = {
    loading: false,
    errors: undefined
}

const ui: Reducer<DashboardUIState> = (state = initialState, action) => {
    switch (action.type) {
        // List
        case DashboardActionTypes.LIST_REQUEST: {
            return { ...state, loading: true, searchParams : action.payload }
        }
        case DashboardActionTypes.LIST_SUCCESS: {
            return { ...state, loading: false }
        }
        case DashboardActionTypes.LIST_ERROR: {
            return { ...state, loading: false, errors: action.payload.errors }
        }
        default: {
            return state
        }
    }
}


const byId: Reducer<{}> = (state = {}, action) => {
    switch (action.type) {
        case DashboardActionTypes.LIST_SUCCESS: {
            var _temp: any = {};
            if (action.payload.isSuccess){  
                // Reset initial search
                action.payload.doc.forEach((item: any) => {
                    _temp[item.id] = item;
                });
                return _temp;
            }else{
                return _temp;
            }
        }
        default: {
            return state
        }
    }
}

const allIds: Reducer<string[]> = (state = [], action) => {
    switch (action.type) {
        case DashboardActionTypes.LIST_SUCCESS: {
            var results:any =[];
            results = action.payload.doc.map((item: any) => item.id);
            return results;
        }
        default: {
            return state
        }
    }
}

// //
// const byCategory: Reducer<{}> = (state = {}, action) => {
//     switch (action.type) {
//         case OrganiserActionTypes.FETCH_SUCCESS: {
            
//             //action.payload.map((item: Course) => item.id)
//             const result:any[] = action.payload.reduce(function (r:any, a:any) {
//                 r[a.Category] = r[a.Category] || [];
//                 r[a.Category].push(a.id);
//                 return r;
//             }, Object.create(null));
//             return result;
//         }
//         case OrganiserActionTypes.ADD_SUCCESS: {
//             const result:any = {...state};
//             result[action.payload.Category].push(action.payload.id)
            
//             return result;
//         }
//         default: {
//             return state
//         }
//     }
// }

// const Category: Reducer<string[]> = (state = [], action) => {
//     switch (action.type) {
//         case OrganiserActionTypes.FETCH_SUCCESS:
//         case OrganiserActionTypes.ADD_SUCCESS:
//         {
//             const results =[...state];
//             action.payload.forEach((item: Course) => {
//                 if(results.some((s)=>s === item.Category)===false)
//                 {
//                     results.push(item.Category);
//                 }
//             });
            
//             return results;
//         }
//         default: {
//             return state
//         }
//     }
// }

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
const OrganisersReducer = combineReducers({
    ui,
    byId,
    allIds,
    // byCategory,
    // Category
})
export default OrganisersReducer
